export const AppConstants = {
  /** Themes */
  darkTheme: 'dark-theme',
  lightTheme: 'light-theme',
  themeStorageKey: 'Theme',
  defaultTheme: 'dark-theme',

  /** Type of Certification Options */
  typeOfCertificationOptions: [
    "New Zealand - June 2007 - New Zealand Customs Service's Secure Export Scheme Program",
    "Canada - June 2008 - Canada Border Services Agency's Partners in Protection Program",
    "Jordan - June 2008 - Jordan Customs Department's Golden List Program",
    "Japan - June 2009 - Japan Customs and Tariff Bureau's Authorized Economic Operator Program",
    "Korea - June 2010 - Korean Customs Service's Authorized Economic Operator Program",
    "European Union - May 2012 - European Union's Authorized Economic Operator Program",
    "Taiwan - November 2012 - Directorate General of Customs, Taiwan Ministry of Finance's - Authorized Economic Operator Program*",
    "Israel - June 2014 - Israel Tax Authority's Authorized Economic Operator Program",
    "Mexico - October 2014 - Authorized Economic Operator Program",
    "Singapore - December 2014 - Singapore Customs' Secure Trade Partnership (STP) Program",
    "Dominican Republic - December 2015 - Authorized Economic Operator Program",
    "Peru - September 2018 - Authorized Economic Operator Program",
    "United Kingdom - January 2021 - Her Majesty's Revenue and Customs' Authorized Economic Operator Program",
    "India - September 2021 - Central Board of Indirect Taxes and Customs (CBIC) - Authorized Economic Operator Program",
    "Uruguay - July 2022 - National Customs Directorate of the Oriental Republic of Uruguay - Qualified Economic Operator Program",
    "Brazil - September 2022 - Federative Republic of Brazil - Brazil Authorized Economic Operator Program",
    "Guatemala - April 2023 - The Superintendence of Tax Administration of Guatemala - Authorized Economic Operator Program",
    "Colombia - April 2023 - Special Administrative Unit Directorate of National Taxes and Customs Republic of Colombia - Authorized Economic Operator Program",
    "South Africa - June 2025 - The South African Revenue Service - Authorized Economic Operator Program"
  ],

  /** Request access Status */
  accessRequestSuccess: "Your Access Request has been submitted successfully.",

  submitMsgError: 'Failed to submit your access request.',
  updateMsgError: 'Failed to update the user details.',
  createMsgError: 'Failed to create the user.',
  downloadFormMsgError: 'Failed to download the form.',
  downloadDocMsgError: 'Failed to download the document.',
  uploadMsgError: 'Failed to upload the document.',
  insufficientPermissionsMsgError: 'You have insufficient permissions to view this folder.',
  uploadedDocSuccessMsg: 'The document has been uploaded successfully.',
  updatedDocDetSuccessMsg: 'The document details have been updated successfully.',
  deletedDocSuccessMsg:'The document has been deleted successfully.',
  deletedDocErrorsMsg:'Failed to delete the document.',
  updatedMsgError: 'Failed to update the document.',
  createdUserSuccessMsg: 'The user has been created successfully.',
  updatedUserDetailsSuccessMsg: 'The user details have been updated successfully.',
  submittedSuccessMsg: 'Your access request has been submitted successfully.',
  accessRequestFailure: "Failed to submit your access request.",
  specialCharAdditionalSettings: 'Special characters are not allowed except . , and space',
  specialCharSuffixHLB: 'Spaces and characters \\ / * ? " < > | are not allowed.',
 // specialCharSNPO: 'Spaces and characters \\ / * ? " < > | are not allowed.',
  specialCharSNPO: 'Special characters are not allowed except . : , and space',
  suffixWarningMsg: 'A document with the same name already exists. modify suffix or continue to upload to replace existing.',
  doctTypeWarningMsg: 'Reselecting Document Type will change the available Additional Information fields.',
  windChilProjectLinkAccessDenied: 'Your Windchill Access Denied',
  previewDocMsgError: 'Failed to preview the document.',

  /** Snackbar service */
  stayDuration: 10000,
  successMessageClass: "sg-success-snack-bar",
  errorMessageClass: "sg-error-snack-bar",
  errorActionName: "DISMISS",

  /** Documents Grid Headers */
  Name: 'Name',
  UploadBy: 'Uploaded By',
  UploadOn: 'Uploaded On',
  SolarPartNumber: 'Solar Part Number',
  SerialNumber: 'Serial Number',
  PurchaseOrder: 'Purchase Order',
  LastEdited: 'Last Edited',

  //User based access permission 
  ReadWrite: 'ReadWrite',
  Read: 'Read',

  //User Roles access
  Admin: 1,
  Supplier: 2,
  SupplyChain : 3,
  SUPPLIER_AP : 11,
  SUPPLIER_ENG_QUALITY : 12,
  SUPPLIER_SHIPPING : 13,
  Receiving : 5,
  Logistics : 6,

  webMasterAddress:'mailto:46d6d03a.solarturbines.com@amer.teams.ms',


  supplierId: "B6615809-042F-4372-BDA6-3CC602DE1C94",
  maxFileSize: 1024,

  /** Documents grid field names */
  nameField: 'name',
  uploadbyField: 'uploadby',
  uploadonField: 'uploadon',

  /** SolarForms Grid Headers */
  Form: 'Form #',
  FormName: 'Form Name',
  FormCategory: 'Category',
  Formdescription: 'Form Description',

  /** SolarForms grid field names */
  formnoField: 'formNumber',
  formnameField: 'formName',
  formdescriptionField: 'description',
  formcategoryField : 'category',
  acceptedFileExtensions: ".doc,.dot,.docx,.docm,.dotx,.dotm,.pdf,.xls,.xlt,.xlm,.xlsx,.xlsm,.xltx,.xltm,.csv,.ppt ,.pot,.pps,.pptx,.pptm,.potx,.potm,.ppsx,.ppsm,.sldx,.sldm,.txt,.bmp,.gif,.tif,.tiff,.jpg,.jpeg,.png,.rtf,.zip",

  /** Supplier Delivery Performance */
  POCreationDate: ' PO Creation Date',

  /** Open Order Grid Headers */
  Position: 'Pos',
  Confirmed: 'Confirmed?',
  Sequence: 'Seq',
  OnTime: 'On Time ?',

  /** Open Order Grid Field Names */
  positionNo: 'positionNo',
  confirmed: 'confirmedStatus',
  sequence:  'seqNo',
  onTime: 'onTime',
  purchaseOrderNo : 'purchaseOrderNo',

  /** Invoice Information Headers */
  CheckNumber: 'CheckNum',
  Amount: 'Amount (US)',

  /** Invoice Information Grid Field Names */
  checkNumber: 'checkNumber',
  amount: 'amount',

  /** Links to the documents */
  'CommunicationGuidelines': 'http://s7d2.scene7.com/is/content/Caterpillar/C10547628',
  'CreditReferenceMemo': 'assets/Files/2021 Credit Reference Letter.pdf',
  'GeneralProvisions': 'https://solarsuppliers.solar.cat.com/gateway/docs/Supplier%20Communications/General_Provisions_of_Purchase_3-18_FINAL.pdf',
  'GasCompressorNotes': 'https://solarsuppliers.solar.cat.com/gateway/docs/Purchasing%20Notes/Gas%20Compressor%20Notes.pdf',
  'QualityNotes': 'https://solarsuppliers.solar.cat.com/gateway/docs/Purchasing%20Notes/Quality%20Notes.pdf',
  'StandardNotes': 'https://solarsuppliers.solar.cat.com/gateway/docs/Purchasing%20Notes/Standard%20Notes.pdf',
  'RouteGuidePrintable': 'https://solarsuppliers.solar.cat.com/gateway/docs/Logistics%20and%20Transportation/US%20Domestic%20Route%20Guide%20-%20Printable.pdf',
  'RouteGuideDesktopReference': 'https://solarsuppliers.solar.cat.com/gateway/docs/Logistics%20and%20Transportation/US%20Domestic%20Route%20Guide%20-%20Desktop%20Reference.xlsx',
  'PackagingAndShipping': 'https://caterpillar.sharepoint.com/teams/SolarTurbinesGlobalLogistics/Shared%20Documents/Forms/AllItems.aspx?id=%2fteams%2fSolarTurbinesGlobalLogistics%2fShared%20Documents%2fPacking%20and%20Shipping%20Guide%2fPackaging%20and%20Shipping%20Guide%20%2D%20PKG%2D1%20%2D%20R%2D8%20%2D%2010%2D18%2D2021%2Epdf&parent=%2fteams%2fSolarTurbinesGlobalLogistics%2fShared%20Documents%2fPacking%20and%20Shipping%20Guide',
  'codeOfConduct': 'https://www.caterpillar.com/en/company/working-together/suppliers/supplier-conduct.html',
  'ToolingSupplierFAQ': 'assets/Legacy content/Solar Turbines Tooling Supplier FAQ.pdf',
  'CommunicationMaterialsShipped': 'assets/Legacy content/MSDS Communique.pdf',
  'ESStandardPaintProgram': 'https://solarsuppliers.solar.cat.com/gateway/docs/Supplier%20Communications/ES9-58_RevY_2.pdf',
  'ESApprovedMaterialsAndSuppliersList': 'https://solarsuppliers.solar.cat.com/gateway/docs/Supplier%20Communications/ES9-58-1P.pdf',
  'FT65001': 'assets/Legacy content/released-FT65001_RevE.pdf',
  'SupplierRequestForRTAGuide': 'https://solarsuppliers.solar.cat.com/gateway/docs/Supplier%20Communications/Supplier%20Request%20for%20RTA%20Guide.pdf'
}


export const FILE_EXTENSION_TYPE = {
  DOC: '.doc',
  DOT: '.dot',
  DOCX: '.docx',
  DOCM: '.docm',
  DOTX: '.dotx',
  DOTM: '.dotm',
  PDF: '.pdf',
  XLS: '.xls',
  XLT: '.xlt',
  XLM: '.xlm',
  XLSX: '.xlsx',
  XLSM: '.xlsm',
  XLTX: '.xltx',
  XLTM: '.xltm',
  CSV: '.csv',
  PPT: '.ppt',
  POT: '.pot',
  PPS: '.pps',
  PPTX: '.pptx',
  PPTM: '.pptm',
  POTX: '.potx',
  POTM: '.potm',
  PPSX: '.ppsx',
  PPSM: '.ppsm',
  SLDX: '.sldx',
  SLDM: '.sldm',
  TXT: '.txt',
  BMP: '.bmp',
  GIF: '.gif',
  TIF: '.tif',
  TIFF: '.tiff',
  JPG: '.jpg',
  JPEG: '.jpeg',
  PNG: '.png',
  RTF: '.rtf',
  ZIP: '.zip',
  STP:'.stp',
};

export const FILE_BLOB_TYPE = {
  DOC: 'application/vnd.ms-word',
  DOT: 'application/vnd.ms-word',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  DOCM: 'application/vnd.ms-word.document.macroEnabled.12',
  DOTX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  DOTM: 'application/vnd.ms-word.template.macroEnabled.12',
  PDF: 'application/pdf',
  XLS: 'application/vnd.ms-excel',
  XLT: 'application/vnd.ms-excel',
  XLM: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSM: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  XLTX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  XLTM: 'application/vnd.ms - excel.template.macroEnabled.12',
  CSV: 'text/csv',
  PPT: 'application/vnd.ms-powerpoint',
  POT: 'application/vnd.ms-powerpoint',
  PPS: 'application/vnd.ms-powerpoint',
  PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PPTM: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  POTX: 'application/vnd.openxmlformats-officedocument.presentationml.template',
  POTM: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
  PPSX: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  PPSM: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
  SLDX: 'application/vnd.openxmlformats-officedocument.presentationml.slide',
  SLDM: 'application/vnd.ms-powerpoint.slide.macroEnabled.12',
  TXT: 'text/plain',
  BMP: 'image/bmp',
  GIF: 'image/gif',
  TIF: 'image/tiff',
  TIFF: 'image/tiff',
  JPG: 'image/jpeg',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  RTF: 'application/rtf',
  ZIP: 'application/zip',
  STP:'application/stp',
};

export const SECTION_TYPE = {
  ComplianceAndRegulations: 'ComplianceAndRegulations',
  HomeSectionsManagement: 'HomeSectionsManagement',
  NewsNUpdatesManagement: 'NewsAndUpdatesManagement'
}

export enum UserRoles {
  ADMIN = 1,
  SUPPLIER = 2,
  SUPPLYCHAIN = 3,
  ENGINEERING = 4,
  SUPPLIER_ENG_QUALITY = 12,
}

export enum RTAStatus {
  Approved = 'Approved',
  Submitted = 'Submitted',
  Draft = 'Draft'
}

export const PRODUCT_SPEC_DATA = {
  introParagraph: "To enhance customer engagement, Solar will utilize QR codes on parts and packaging labels. These QR codes are uniquely generated for each product and link to the detail page Shop.Solarturbines.com/Part#  When preparing packaging, a Part detail or Homepage QR code is acceptable.  Ensure this is printed and clearly visible on the Solar Branded Label along with the Part number.  The label is ideally placed in a flat, unobstructed area for easy scanning. Avoid placing QR codes near folds, seams, or reflective surfaces that may interfere with readability.  If room allows, include a CTA (call to action).  Place the CTA underneath the QR code.",
  stickerSpecs: [
    "Size: 1/2 x 1/2 inches (minimum recommended for readability)",
    "Placement: Flat, unobstructed surface on packaging",
    "Clear Margin: Minimum 0.125 inches (3mm) of clear space around the QR code",
    "Print Quality: High contrast",
    "Finish: Matte preferred (to reduce glare and improve scan reliability)",
    "Durability: Use weather-resistant or smudge-proof material if exposed to moisture or abrasion"
  ],
  fileSpec: [
    "Format Options: EMF (Vector extension preferred for scalability and sharp print quality);<br/> PNG or PDF (300 DPI)also acceptable",
    "Resolution: 300 DPI minimum for raster formats (e.g., PNG)",
    "Color Mode: Black and white (monochrome) for maximum scan reliability"
  ],
  partQRBullete: [
    "Enter the part number into the search box",
    "Click on “Download QR” to generate and download the QR Code images."
  ],
  CTA: [
    "A QR code's CTA (Call to Action) is a short, clear instruction placed next to a QR code that tells users what they should do and what they’ll get by scanning it. It helps increase engagement by setting expectations and encouraging action."
  ],
  SOLAR_LOGO: [
    "Solar® is a registered trademark for Solar Turbines Products.  When used in private labeling, the Solar® brand assures customers of compliance with rigorous performance and safety standards.  To maintain brand integrity and legal compliance, trademark use is detailed in Engineering Specification ES9-300.  Ensure all product labeling, packaging, and other materials using the Solar® mark are reviewed and approved by the brand compliance team in accordance with ES9-300. Below are the iconography files approved for use."
  ]
}	 

export const DATE_RANGE_LIST = [
  { label:"Last 30 days", value: 30 },
  { label: "Last 60 days", value: 60 },
  { label: "Last 90 days", value: 90 },
  { label: "Last 120 days", value: 120 }
];
